<!-- *ngIf="session"-->
<div *ngIf="session" class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url(&quot;assets/img/Background formulaire candidature Force-N.jpeg&quot;);
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center mr-auto ml-auto">
      <app-card-form style="opacity: 0.8">
        <div class="flex justify-center font-bold w-full mb-6 md:mb-2">
          Tous les champs marqués d'un * sont obligatoires et doivent être
          remplis.
        </div>

        <div id="page-one">
          <!--START=> A SPPRIMER APRES VOLONTAIRE -->
          <div
            class="flex justify-center mb-10"
            *ngIf="paramValue === 'VOLONTAIRE'"
          >
            <img
              src="assets/img/UNCK-FORCE-N.jpg"
              alt="logo"
              width="648"
              height="188"
            />
          </div>
          <ng-container *ngFor="let block of imageBlocks">
            <div
              class="flex justify-center mb-10"
              *ngIf="paramValue === 'VOLONATIRE'"
            >
              <div
                *ngFor="let image of block.images"
                class="mt-3 flex justify-center mb-10"
              >
                <img [src]="image" alt="logo" width="300" height="188" />
              </div>
            </div>
          </ng-container>
          <!--END=> A SPPRIMER APRES VOLONTAIRE -->

          <div class="flex justify-center mb-10" *ngIf="paramValue === 'FODE'">
            <div>
              <img
                src="assets/img/UNCK-FORCE-N.jpg"
                alt="logo"
                width="648"
                height="188"
              />
            </div>
          </div>

          <!--PARTENER LOGo for benin and senegal-->
          <ng-container *ngFor="let block of imageBlocks">
            <div
              class="flex flex-wrap justify-center items-center gap-8 mb-10"
              *ngIf="paramValue === block.condition && !isBenin "
            >
              <div *ngFor="let image of block.images">
                <img
                  [src]="image"
                  alt="logo"
                  class="max-w-[300px] max-h-[188px] object-contain"
                />
              </div>
            </div>
          </ng-container>

          <!--Benin-->
        <ng-container *ngFor="let block of imageBlocks">
          <div *ngIf="paramValue === block.condition && isBenin" class="logo-container">
            <img *ngFor="let image of block.images" [src]="image" class="logo-image" alt="Logo">
          </div>
        </ng-container>

          <!-- END PARTENER LOGO-->

          <!--TABA TABA-->
          <div
            class="flex justify-center mb-10"
            *ngIf="paramValueDER_TABA == 'TABA'"
          >
            <div class="mt-6">
              <img
                src="assets/img/UNCK-FORCE-N.jpg"
                alt="logo"
                width="300"
                height="188"
              />
              <img
                src="assets/img/tabaBis.jpg"
                alt="logo"
                width="300"
                height="188"
              />
            </div>
          </div>
          <!-- END TABA TABA-->

          <!--PARTENER LOGFO-->
          <ng-container *ngFor="let block of imageBlocks">
            <div
              class="flex justify-center mb-10"
              *ngIf="paramValueDER_TABA === block.condition"
            >
              <div
                *ngFor="let image of block.images"
                class="mt-3 flex justify-center mb-10"
              >
                <img [src]="image" alt="logo" width="300" height="188" />
              </div>
            </div>
          </ng-container>

          <!-- END PARTENER LOGO-->

          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE DE CANDIDATURE
              </span>
              <br />
              {{ appelName }}
              <!-- Certificats E-business et acculturation au numérique -->
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
          <div class="flex justify-center items-center">
            <div
              class="text-center"
              *ngIf="!['ASP', 'ADEPME'].includes(paramValue ?? '')"
            >
                            <span class="font-bold text-2xl">
                                Délai limite pour le dépôt des dossiers de
                candidature               </span
              >
                            <br /><br />
                            {{
                appelCloseDate | date: "EEEE d MMMM y, à "
              }}
              23h:59mn             
            </div>
                        <!--A SUPPRIMER-->
                        
            <div
              class="text-center"
              *ngIf="paramValue === 'ASP' || paramValue === 'ADEPME'"
            >
                            <span class="font-bold text-2xl">
                                Délai limite pour le dépôt des dossiers de
                candidature               </span
              >
                            <br /><br />
                            12/07/2026 à 23h:59mn             
            </div>
                        <!--END A SUPPRIMER-->
          </div>
        </div>
        <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <div class="text-justify">
            Veuillez fournir des informations exactes. Toute information erronée
            pourrait entraîner le rejet de votre candidature. En cas
            d'admission, les notifications, les comptes d'accès aux plateformes
            et divers autres documents seront générés à partir des informations
            ci-dessous soumises. Toute constatation d'une information inexacte
            fournie pourrait valoir une exclusion de la formation.
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="soumissionForm">
            <div class="grid lg:grid-cols-2 gap-2 my-6 m-0">
              <div class="relative z-0 w-full mb-5 group">
                <div class="col-span-1 label">
                  <div class="lg:me-3">
                    Merci de choisir le certificat qui vous
                    intéresse&nbsp;:<span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="isFieldInvalid('certificatChoice')"
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                </div>
              </div>

              <div
                class="box-certificats pt-0 md:pt-2 relative z-0 w-full group grid grid-cols-2 gap-4 gap-x-24 m-0"
                *ngIf="paramValue != 'AVOC'"
              >
                <div
                  *ngFor="
                    let certificat of certificatDynamicOption;
                    let i = index
                  "
                  [ngClass]="{ 'col-span-1': true, 'mb-4': (i + 1) % 3 !== 0 }"
                >
                  <div class="flex items-center">
                    <input
                      type="radio"
                      [id]="'certificat_' + certificat.id"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                      formControlName="certificatChoice"
                      [value]="certificat.id"
                      name="certificatChoice"
                      [style.border]="
                        isFieldInvalid('certificatChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      [for]="'certificat_' + certificat.id"
                      class="ml-2 text-sm font-medium text-gray-900"
                    >
                      {{ certificat.name }}
                    </label>
                  </div>
                </div>
              </div>

              <!---################################SUPPRIMER APRES L'APPEL DE AVOC#############################-->
              <div
                class="box-certificats pt-0 md:pt-2 relative z-0 w-full group grid grid-cols-2 gap-4 gap-x-24 m-0"
                *ngIf="paramValue === 'AVOC'"
              >
                <div>
                  <div class="flex items-center">
                    <input
                      type="radio"
                      [id]="'certificat_' + 1930"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                      formControlName="certificatChoice"
                      [value]="1930"
                      name="certificatChoice"
                      [style.border]="
                        isFieldInvalid('certificatChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      [for]="'certificat_' + 1930"
                      class="ml-2 text-sm font-medium text-gray-900"
                    >
                      Intelligence artificielle pour tous
                    </label>
                  </div>
                </div>
              </div>
              <!---################################SUPPRIMER APRES L'APPEL DE AVOC THE END#############################-->
            </div>

            <!---INFOS PERSON-->
            <div class="flex justify-between gap-2 gap-6 my-6">
              <span class="font-bold text-2xl"
                >I. INFORMATIONS PERSONNELLES</span
              >
            </div>
            <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

            <div class="grid lg:grid-cols-3 lg:gap-6 m-0">
              <div class="relative z-0 w-full group">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Prénom - Nom
                    <span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="
                      isFieldInvalid('firstname') || isFieldInvalid('lastname')
                    "
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input
                  type="text"
                  id="prenom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                  formControlName="firstname"
                  [style.border]="
                    isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                  "
                />
                <div class="mt-1 text-sm">
                  <p>Prénom</p>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input
                  type="text"
                  id="nom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                  formControlName="lastname"
                  [style.border]="
                    isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                  "
                />
                <div class="mt-1 text-sm">
                  <p>Nom</p>
                </div>
              </div>
            </div>
            <div class="relative">
              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Date de naissance
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDate')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                    <!-- <div *ngIf="checkValidAge()" style="color: #eb1c1c">
                      L'âge limite de candidature est de 35 ans
                    </div> -->
                  </div>
                </div>
                <div class="col-span-2">
                  <div class="flex justify-between gap-3">
                    <div class="w-full">
                      <input
                        type="date"
                        formControlName="selectedDate"
                        id="year"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        [style.border]="
                          isFieldInvalid('selectedDate')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />

                      <div class="mt-1">
                        <p class="text-sm">
                          Saisir votre date de naissance ou vous pouvez
                          directement selectionner la date dans l'agenda.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid md:grid-cols-3 md:gap-6 mx-0 my-4">
              <div class="relative z-0 w-full mb-0 md:mb-2 group pt-0 md:pt-3">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Sexe
                    <span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="isFieldInvalid('selectedSexe')"
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-2 group">
                <div class="flex items-center">
                  <input
                    formControlName="selectedSexe"
                    id="bordered-radio"
                    type="radio"
                    value="Homme"
                    name="selectedSexe"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('selectedSexe') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <label
                    for="bordered-radio"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >Masculin</label
                  >
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-2 group">
                <div class="flex items-center">
                  <input
                    formControlName="selectedSexe"
                    id="bordered-radio"
                    value="Féminin"
                    type="radio"
                    name="selectedSexe"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('selectedSexe') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <label
                    for="bordered-radio"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >Féminin</label
                  >
                </div>
              </div>
            </div>
            <div class="grid lg:grid-cols-3 lg:gap-6 m-0">
              <div class="relative z-0 w-full group">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Numéro de téléphone
                    <span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="
                      isFieldInvalid('phoneNumber') ||
                      isFieldInvalid('phoneCode')
                    "
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                  <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                    Tapez seulement des nombres!
                  </div> -->
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <select
                  type="text"
                  id="prenom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                  formControlName="phoneCode"
                  [style.border]="
                    isFieldInvalid('phoneCode') ? '2px solid #eb1c1c' : ''
                  "
                >
                  <option
                    *ngFor="let phonecode of phoneCode"
                    [value]="phonecode.phoneCode"
                  >
                    {{ phonecode.phoneCode }}
                  </option>
                </select>
                <div class="mt-1 text-sm">
                  <p>Indicatif pays</p>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input
                  type="tel"
                  id="phoneNumber"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                  formControlName="phoneNumber"
                  onlyNumber
                  [style.border]="
                    isFieldInvalid('phoneNumber') ? '2px solid #eb1c1c' : ''
                  "
                />
                <div class="mt-1 text-sm">
                  <p>Numéro de téléphone</p>
                </div>
              </div>
            </div>

            <div class="grid md:grid-cols-3 md:gap-6 mt-6 mb-0 mx-0">
              <div class="relative z-0 w-full mb-0 md:mb-5 group">
                <div class="col-span-1 label">
                  <div class="lg:me-3">
                    Ce numéro est-il disponible sur <br />
                    Whatsapp?<span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="isFieldInvalid('isWhatsApp')"
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-5 group">
                <div class="flex items-center">
                  <input
                    formControlName="isWhatsApp"
                    id="bordered-radio-1"
                    type="radio"
                    value="OUI"
                    name="isWhatsApp"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <label
                    for="bordered-radio-1"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >Oui</label
                  >
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-5 group">
                <div class="flex items-center">
                  <input
                    formControlName="isWhatsApp"
                    checked
                    id="bordered-radio-1"
                    type="radio"
                    value="NON"
                    name="isWhatsApp"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <label
                    for="bordered-radio-1"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >Non</label
                  >
                </div>
              </div>
            </div>

            <div
              class="grid md:grid-cols-3 md:gap-6 m-0 mt-4 md:mt-2 mb-8"
              *ngIf="showWhatsAppNumberFields"
            >
              <div class="relative z-0 w-full group">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Numéro Whatsapp
                    <span style="color: red">*</span>
                  </div>
                  <div
                    *ngIf="
                      isFieldInvalid('whatsAppNumber') ||
                      isFieldInvalid('phoneCodeForWhatsApp')
                    "
                    style="color: #eb1c1c"
                  >
                    Champ requis
                  </div>
                  <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                    Tapez seulement des nombres!
                  </div> -->
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <select
                  type="text"
                  id="prenom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                  formControlName="phoneCodeForWhatsApp"
                  [style.border]="
                    isFieldInvalid('phoneCodeForWhatsApp')
                      ? '2px solid #eb1c1c'
                      : ''
                  "
                >
                  <option
                    *ngFor="let phonecode of phoneCodeWhatsapp"
                    [value]="phonecode.phoneCode"
                  >
                    {{ phonecode.phoneCode }}
                  </option>
                </select>
                <div class="mt-1 text-sm">
                  <p>Indicatif pays</p>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input
                  type="tel"
                  id="whatsAppNumber"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                  formControlName="whatsAppNumber"
                  onlyNumber
                  [style.border]="
                    isFieldInvalid('whatsAppNumber') ? '2px solid #eb1c1c' : ''
                  "
                />
                <div class="mt-1 text-sm">
                  <p>Numéro de téléphone</p>
                </div>
              </div>
            </div>

            <!-- Formulaire précédemment fourni -->
            <!--*ngIf="pageOne"-->
            <div>
              <div formGroupName="emailGroup">
                <div class="grid md:grid-cols-3 md:gap-6 mt-5 md:mb-2 m-0">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Adresse email
                        <span style="color: #ff0000">*</span>
                      </div>

                      <div
                        *ngIf="isFieldInvalidForMails('emailGroup.email')"
                        style="color: #eb1c1c"
                      >
                        Champ requis
                      </div>
                      <div
                        *ngIf="isMailFieldInvalid('email')"
                        style="color: #eb1c1c"
                      >
                        Format de l'email invalide.
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <input
                        type="text"
                        id="email"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        placeholder="Par ex : monemail@exemple.com"
                        formControlName="email"
                        [style.border]="
                          isFieldInvalid('emailGroup.email')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="grid md:grid-cols-3 md:gap-6 m-0 md:mt-4">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3"></div>
                    </div>

                    <div
                      *ngIf="isFieldInvalidForMails('emailGroup.confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                    <div
                      *ngIf="isMailFieldInvalid('confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Format de l'email invalide.
                    </div>

                    <div
                      *ngIf="showEmailErrors$ | async"
                      style="color: #eb1c1c"
                    >
                      Mettez des mails identiques
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="email"
                        id="confirmEmail"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="confirmEmail"
                        placeholder="Veuillez confirmer votre adresse email"
                        [style.border]="
                          isFieldInvalid('emailGroup.confirmEmail')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <div class="mt-1 text-sm">
                        <p>
                          Pour être sûr de bien recevoir nos mails, merci
                          d'utiliser des adresses type Gmail, Evitez les
                          adresses Outlook, Yahoo, Hotmail et professionnelles.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 md:gap-6 mb-6 m-0">
                <div class="relative z-0 w-full mb-0 md:mb-5 group pt-4">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Nationalité
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedCountry')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="selectedCountry"
                      id="bordered-radio-local"
                      type="radio"
                      [value]="isBenin ? 'Bénin' : 'Sénégal'"
                      name="selectedCountry"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 ..."
                      [style.border]="
                        isFieldInvalid('selectedCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio-local"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ isBenin ? "Béninoise" : "Sénégalaise" }}
                    </label>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="selectedCountry"
                      checked
                      id="bordered-radio-2"
                      type="radio"
                      value="Autre"
                      name="selectedCountry"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autre</label
                    >
                  </div>
                </div>
              </div>
              <!-- if other coutry -->

              <div
                class="grid md:grid-cols-3 md:gap-6 my-6 m-0"
                *ngIf="
                  soumissionForm.get('selectedCountry')?.value !==
                    (isBenin ? 'Bénin' : 'Sénégal') &&
                  (soumissionForm.get('selectedCountry')?.value != null ||
                    soumissionForm.get('selectedCountry')?.value != undefined)
                "
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre nationalité
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('otherCountry')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      type="text"
                      id="otherCountry"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      formControlName="otherCountry"
                      [style.border]="
                        isFieldInvalid('otherCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let country of countries"
                        [value]="country.name"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >II. SITUATION ACADEMIQUE ET PROFESSIONNELLE</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <!--*ngIf="showDegreeDiv"-->
              <div
                class="grid md:grid-cols-3 md:gap-6 my-6 m-0"
                *ngIf="paramValue === 'MFP'"
              >
                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Precisez votre affectation professionnelle
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('typeAffectation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="typeAffectation"
                      id="typeaffect"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('typeAffectation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let type of typeAffectation"
                        [value]="type"
                      >
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                class="grid md:grid-cols-3 md:gap-6 m-0 mt-4 md:mt-2 mb-8"
                *ngIf="soumissionForm.value.typeAffectation"
              >
                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3 whitespace-nowrap">
                      Renseigner le nom
                      <span
                        class="ml-1"
                        *ngIf="
                          soumissionForm.value.typeAffectation ==
                          typeAffectation[0]
                        "
                      >
                        de l'établissement
                      </span>
                      <span
                        class="ml-1"
                        *ngIf="
                          soumissionForm.value.typeAffectation ==
                          typeAffectation[1]
                        "
                      >
                        de la direction ou du service
                      </span>
                      <span style="color: red"> *</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('nomAffectation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="text"
                      id="nomAffectation"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                      formControlName="nomAffectation"
                      [style.border]="
                        isFieldInvalid('nomAffectation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 md:gap-6 my-6 m-0">
                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Diplôme le plus élevé obtenu (ou équivalent)<span
                        style="color: red"
                        >*</span
                      >
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDiplome')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDiplome"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDiplome')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let diplome of diplomes"
                        [value]="diplome.name"
                      >
                        {{ diplome.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0 mb-0 lg:mb-6">
                <div class="relative z-0 w-full m-0 lg:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Statut Actuel
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('professionnalSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>

                <!-- Colonne 1 -->
                <div class="relative z-0 w-full group grid grid-rows-3 m-0">
                  <div
                    *ngFor="
                      let option of statutOptions.slice(0, 3);
                      let i = index
                    "
                  >
                    <input
                      type="checkbox"
                      [id]="'statut_' + i"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [value]="option"
                      (change)="onCheckboxChange($event)"
                      [checked]="
                        soumissionForm
                          .get('professionnalSituation')
                          ?.value.includes(option)
                      "
                    />
                    <label
                      [for]="'statut_' + i"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ option }}
                    </label>
                  </div>
                </div>

                <!-- Colonne 2 -->
                <div class="relative z-0 w-full group grid grid-rows-3 m-0">
                  <div
                    *ngFor="let option of statutOptions.slice(3); let i = index"
                  >
                    <input
                      type="checkbox"
                      [id]="'statut_' + (i + 3)"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [value]="option"
                      (change)="onCheckboxChange($event)"
                      [checked]="
                        soumissionForm
                          .get('professionnalSituation')
                          ?.value.includes(option)
                      "
                    />
                    <label
                      [for]="'statut_' + (i + 3)"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ option }}
                    </label>
                  </div>
                </div>
              </div>

              <hr
                class="h-px mb-8 bg-gray-300 border-0 dark:bg-gray-700 lg:mt-8 mt-4"
              />

              <div class="grid lg:grid-cols-3 lg:gap-6 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Votre projet à l’issue du programme&nbsp;?<span
                        style="color: red"
                        >*</span
                      >
                    </div>
                    <div
                      *ngIf="isFieldInvalid('yourProject')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3 m-0">
                  <div>
                    <input
                      type="radio"
                      id="yourProject_1"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Poursuivre mes études"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_1"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Poursuivre mes études</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_2"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Lancer mon entreprise"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_2"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Lancer mon entreprise</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="yourProject_3"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Chercher un emploi"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_3"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Chercher un emploi</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_4"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Retourner dans mon entreprise"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_4"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Retourner dans mon entreprise</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_5"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Aucun des projets"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_5"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Aucun des projets</label
                    >
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">III. INCLUSION</span>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid lg:grid-cols-3 lg:gap-6 mt-6 mb-0 lg:mb-4 mx-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Région de résidence
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedRegion')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-0 lg:mb-5 group">
                    <select
                      formControlName="selectedRegion"
                      id="cities"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedRegion')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let region of regions"
                        [value]="region.name"
                      >
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- *ngIf="showZoneOfResidenceDiv()" -->
              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Zone de résidence
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedZone')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2">
                  <select
                    formControlName="selectedZone"
                    id="zone"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    [style.border]="
                      isFieldInvalid('selectedZone') ? '2px solid #eb1c1c' : ''
                    "
                  >
                    <option *ngFor="let zone of zones" [value]="zone.name">
                      {{ zone.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!--!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! PLEANSE DON'T DELETE THIS CODE COMMENTED!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!-->

              <!-- <div class="grid lg:grid-cols-3 gap-6 my-6 m-0">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Êtes-vous en situation de handicap? &nbsp;
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="
                        soumissionForm.get('handicapSituations')?.invalid &&
                        soumissionForm.get('handicapSituations')?.touched
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2">
                  <select
                    formControlName="inHandicapSituation"
                    id="inHandicapSituation"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    [style.border]="
                      isFieldInvalid('inHandicapSituation')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  >
                    <option value="Oui">Oui</option>
                    <option value="Non">Non</option>
                  </select>
                </div>
              </div> -->

              <!-- Affichage des choix uniquement si "Oui" est sélectionné -->
              <!-- *ngIf="
                  soumissionForm.get('inHandicapSituation')?.value === 'Oui'
                "-->
              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <!-- <div class="lg:flex lg:me-3">
                      Sélectionnez votre type de handicap : &nbsp;
                      <span style="color: red">*</span>
                    </div> -->
                    <div class="lg:flex lg:me-3">
                      Êtes-vous en situation de handicap&nbsp;?
                      <!-- <span style="color: red">*</span> -->
                    </div>
                    <!-- <div
                      *ngIf="isFieldInvalid('handicapSituations')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div> -->
                  </div>
                </div>

                <!-- Liste dynamique des handicaps -->
                <div class="relative z-0 w-full group grid grid-rows-3 m-0">
                  <div *ngFor="let option of handicapOptions; let i = index">
                    <input
                      type="checkbox"
                      [id]="'handicap_' + i"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [value]="option"
                      (change)="onHandicapCheckboxChange($event)"
                      [checked]="
                        soumissionForm
                          .get('handicapSituations')
                          ?.value.includes(option)
                      "
                    />
                    <label
                      [for]="'handicap_' + i"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {{ option }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0">
                <div class="relative z-0 w-full mb-0 lg:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Êtes-vous dans l’une des situations suivantes&nbsp;?<span
                        style="color: red"
                        >*</span
                      >
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3 m-0">
                  <div>
                    <input
                      type="radio"
                      id="selectedSituation1"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Réfugié"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation1"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Réfugié</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="selectedSituation2"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Déplacé"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation2"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Déplacé</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="selectedSituation3"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Non concerné"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation3"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Non concerné</label
                    >
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
                <div class="text-justify flex text-sm gap-2 align-items:start">
                  <div>
                    <input
                      type="checkbox"
                      id="conditions"
                      class="h-5 w-5 mb-3 mr-3 mt-1 rounded"
                      formControlName="conditions"
                      value="Accepté"
                      name="conditions"
                      [style.border]="
                        isFieldInvalid('conditions') ? '2px solid #eb1c1c' : ''
                      "
                    />
                  </div>
                  <div class="text-xs md:text-sm">
                    En déposant ma candidature, je m'engage si je suis admis à
                    suivre intégralement le parcours d'accompagnement (les
                    certificats de compétences, le renforcement en
                    employabilité, le développement des compétences
                    transversales ...) . Je certifie que l'ensemble des
                    informations communiquées sont exactes et que toute fausse
                    déclaration m'expose à une exclusion du programme.
                    J'autorise FORCE-N à conserver et à utiliser mes données
                    dans le cadre du programme. Les correspondances, les
                    certificats de réussite, l'accès aux plateformes de
                    formation et les badges seront générés à partir des
                    informations personnelles soumises ci-dessous. Veuillez donc
                    fournir des informations correctes et appropriées
                    <span style="color: red">*</span>
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
            </div>
            <div>
              <app-spinner *ngIf="showSpinner"></app-spinner>
            </div>
            <div class="flex justify-center items-center">
              <button
                [disabled]="showSpinner"
                type="submit"
                class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm btn-login"
                (click)="onSubmitForm()"
              >
                Soumission
              </button>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>

<!-- Pop-up d'alerte -->
<div
  *ngIf="showPopup"
  class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
>
  <div class="bg-white p-6 rounded-lg shadow-lg text-center">
    <h2 class="text-lg font-semibold text-red-600">Attention</h2>
    <p class="mt-2">
      Veuillez remplir tous les champs requis avant de soumettre.
    </p>
    <button
      (click)="showPopup = false"
      class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md"
    >
      OK
    </button>
  </div>
</div>

<!--************************************************************-->
<!--noSession-->
<div
  *ngIf="noSession"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Les candidatures sont closes pour cette session. Restez en contact
              avec nous sur
              <a style="color: blue" href="https://force-n.sn/"
                >https://force-n.sn/</a
              >
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--applied-->
<div
  *ngIf="applied"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Vous avez déjà soumissionné!
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--admission-->
<div
  *ngIf="false"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Vous étes déja admis dans ce parcour.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="invalid"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              <h3
                class="mb-2 text-lg font-normal text-red-600 dark:text-red-400"
              >
                Lien invalide, veuillez retaper vos informations.
              </h3>
              <p class="text-sm text-green-600 dark:text-green-400">
                Si vous êtes un agent FABAMA ou DER, assurez-vous d'utiliser le
                lien correct qui vous a été communiqué.
              </p>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="isLoading"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
    
  <div
    class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center gap-4"
  >
        <svg class="animate-spin h-10 w-10 text-orange-500" viewBox="0 0 24 24">
            
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
            
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      ></path>
          
    </svg>

        <span class="text-gray-700 font-semibold">
            Soumission en cours...     </span
    >

      
  </div>
</div>
<!-- Message Benin candidat -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity"
  *ngIf="isCandidateBenin">
  <div class="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-8 shadow-2xl transition-all">

    <div class="flex flex-col items-center text-center">

      <div class="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-blue-500" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="Circle-info-icon-path-here"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <h2 class="mb-2 text-2xl font-bold text-gray-900">
        Informations
      </h2>

      <p class="mb-8 text-gray-500">
        {{errorMessageBenin}}
      </p>

      <div class="w-full flex justify-center">
        <button type="button" (click)="isCandidateBenin = false"
          class="inline-flex w-full justify-center rounded-xl bg-gray-900 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 transition-all active:scale-95">
          fermer
        </button>
      </div>
    </div>

  </div>
</div>